/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringTTLOCriteriaInput
 */
export interface StringTTLOCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof StringTTLOCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringTTLOCriteriaInput
     */
    value?: string | null;
}

export function StringTTLOCriteriaInputFromJSON(json: any): StringTTLOCriteriaInput {
    return StringTTLOCriteriaInputFromJSONTyped(json, false);
}

export function StringTTLOCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringTTLOCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function StringTTLOCriteriaInputToJSON(value?: StringTTLOCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': value.value,
    };
}


